///
/// EarthBrowser
///
/// Migration v5 to v6: Add buoy dataset type support
///
/// This migration ensures the visibleDatasets array can include "buoy"
/// and validates any existing dataset arrays.
///

interface StateV5 {
	earthbrowser?: {
		visibleDatasets?: string[]
		buoySearchParams?: unknown
	}
}

/**
 * Migration from version 5 to 6: Add buoy dataset support
 * - Validates visibleDatasets array to ensure it can include "buoy"
 * - Adds buoySearchParams with default values
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV5toV6(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV5
	const oldEarthbrowser = s.earthbrowser || {}

	// Ensure visibleDatasets is a valid array
	const visibleDatasets = Array.isArray(oldEarthbrowser.visibleDatasets)
		? [...oldEarthbrowser.visibleDatasets]
		: ["cloud", "earthquake", "satellite", "aurora", "GFS_TEMPERATURE", "GFS_SNOW", "volcano"]

	// Filter out any invalid dataset types that might have crept in
	const validDatasets = visibleDatasets.filter((d: string) =>
		["satellite", "airport", "buoy", "earthquake", "volcano",
		 "location", "cloud", "stars", "aurora", "wildfire",
		 "weather", "package", "devtools", "GFS_TEMPERATURE", "GFS_SNOW",
		 ""].includes(d)
	)

	// Create new earthbrowser state with buoySearchParams
	const newEarthbrowser = {
		...oldEarthbrowser,
		visibleDatasets: validDatasets,
		buoySearchParams: oldEarthbrowser.buoySearchParams ?? { count: 500, dart: false }
	}

	// Return completely new state object
	return {
		...s,
		earthbrowser: newEarthbrowser
	}
}
